import React from 'react';
import { ThemeProvider as StyledThemeProvider, } from 'styled-components';
import ThemeContext from './ThemeContext';
export default function ThemeProvider(props) {
    return (React.createElement(ThemeContext.Provider, { value: props.theme },
        React.createElement(StyledThemeProvider, { theme: props.theme }, props.children)));
}
//# sourceMappingURL=ThemeProvider.js.map